<popup header="{{'訊息'|i18n:'chm00004690':null}}" [(visible)]="display" modal="modal" width="400" responsive="true"
    (onHide)="onHide()" (onShow)="onShow()">

    <div class="modal_area logout">
        <p class="center">{{'請確認是否要登出？'|i18n:'chm00003848':null}}</p>


        <div class="btn_box">
            <commandButton styleClass="submit_btn close-dialog no-btn-ouline" (onClick)="onConfirm()">
                {{'確定'|i18n:'Confirm':null}}</commandButton>
            <commandButton styleClass="submit_btn close-dialog reset no-btn-ouline" (onClick)="onClose()">
                {{'取消'|i18n:'common00003513':null}}</commandButton>
        </div>
    </div>

</popup>
